import React from "react";
import NewsletterEleven from "../component/NewsletterEleven";

function NewsletterElevenContainer() {
  return <NewsletterEleven />;
}

export default NewsletterElevenContainer;
